// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

import styled from '@emotion/styled';
import { Typography } from '@kintent/glide';

export const Navigation = styled.nav`
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  right: 0;

  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-areas: 'logo menu trustcloud';
  gap: 32px;

  align-items: center;

  padding: 20px 32px;

  background-color: ${({ theme }) => theme.components.header.navigation.backgroundColor};

  min-height: 82px;

  margin-left: auto;
  margin-right: auto;
  width: 100%;

  & .login-actions-container {
    width: 300px;
    justify-content: flex-end;
  }
`;

export const LogoContainer = styled.div`
  justify-self: start;
  grid-area: logo;

  width: 300px;
`;

export const TrustShareLogoContainer = styled.a`
  display: flex;

  max-width: 150px;
  height: 40px;
`;

export const MenuItemsContainer = styled.div`
  justify-self: center;
  grid-area: menu;
`;

export const NavigationItemList = styled.ul`
  display: flex;
  gap: 32px;

  list-style: none;
`;

export const NavigationItem = styled(Typography)`
  text-decoration: none;

  font-weight: 500;
  font-family: Lato;

  &:hover {
    text-decoration: underline;
  }

  &.active {
    color: ${({ theme }) => theme.components.header.navigation.textColor};
    text-decoration: underline;
  }
`;

export const TrustCloudCTA = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  padding-right: 8px;
`;
